// Generated by tools/sync-web-assets.mjs. Do not edit by hand.
export const APP_VERSION = "0.1.1";
